module.exports = __webpack_public_path__ + "img/list41.ffc4a5f9.jpeg";